<template>
    <v-card class="pa-3" v-if="superUser || permission" :value="$route.path">
        <v-row class="d-flex justify-center">
            <v-col cols="12" md="12" sm="12">
                <v-card elevation="0">
                    <v-row no-gutters>
                        <v-col cols="12" class="pr-2 pb-0">
                            <v-toolbar flat height="80">
                            
                                <div>
                                    <b-select
                                        :items="statuses"
                                        v-model="filteredStatus[0]"
                                        class="text-capitalize font-weight-bold"
                                        :suffix="translations.filterByStatus[lang]"
                                        append-icon="mdi-chevron-down"
                                        type="filter"
                                        no-clear-icon
                                        return-object
                                    >
                                    </b-select>
                                </div>
                                <div>
                                    <b-select
                                        :items="events"
                                        :item-text="`type`"
                                        item-value="type"
                                        v-model="filteredEvents"
                                        class="text-capitalize font-weight-bold"
                                        multiple
                                        :suffix="translations.filterbyEvents[lang]"
                                        append-icon="mdi-chevron-down"
                                        type="filter"
                                        no-clear-icon
                                    >
                                    </b-select>
                                </div>
                                <div v-if="filteredStatus.length || filteredEvents.length" class="pt-2">
                                    <v-tooltip color="secondary" top>
                                        <template v-slot:activator="{ on }">
                                   <v-btn icon fab v-on="on" @click="resetFilters"><v-icon>mdi-arrow-u-left-top</v-icon></v-btn>
                                </template>
                                <span
                                        class="font-weight-bold"
                                        v-text="translations.resetFilters[lang]"
                                    ></span>
                                </v-tooltip>
                                </div>
                                <v-spacer></v-spacer>
                                <v-col cols="12" sm="4" class="pt-0">
                                    <b-search-field
                                        v-model="search"
                                    ></b-search-field>
                                </v-col>
                            </v-toolbar>
                            <v-col
                                class="pt-0"
                                :class="[
                                    (!filteredStatus.length &&
                                        !filteredEvents.length &&
                                        'py-0') ||
                                        'mt-n2'
                                ]"
                            >
                                <v-chip
                                    v-for="(status, index) in filteredStatus"
                                    :key="status.value"
                                    class="ma-2"
                                    close
                                    dark
                                    @click:close="
                                        removeFilter('filteredStatus', index)
                                    "
                                >
                                    {{ status.text }}
                                </v-chip>
                                <v-chip
                                    v-for="(event, index) in filteredEvents"
                                    :key="event"
                                    class="ma-2"
                                    close
                                    dark
                                    @click:close="
                                        removeFilter('filteredEvents', index)
                                    "
                                >
                                    {{ event }}
                                </v-chip>
                            </v-col>
                            <b-data-table
                                :headers="headers"
                                :loading="loading"
                                :items="webhookLogs"
                                class="b-outlined rounded-0 webhook-logs-table"
                                :page.sync="page"
                                @page-sync="p => (page = p)"
                                disable-sort
                            >
                                <template v-slot:item.event_type="{ item }">
                                    <v-col
                                        class="d-flex flex-column justify-center align-content-space-between"
                                    >
                                        <span class="font-weight-medium">
                                            {{ item.event_name }}
                                        </span>
                                        <div
                                            v-for="(type,
                                            index) in item.event_type.split(
                                                '.'
                                            )"
                                            :key="index"
                                            class="font-weight-medium d-flex justify-center align-content-space-between flex-column"
                                        >
                                            <v-icon>mdi-arrow-down</v-icon>
                                            <span> {{ type }}</span>
                                        </div>
                                    </v-col>
                                </template>
                                <template v-slot:item.endpoint_url="{ item }">
                                    <v-list-item
                                        link
                                        class="d-flex justify-center"
                                        @click="openDetailsDialog(item)"
                                        ><span
                                            class="text-decoration-underline"
                                            style="color:blue"
                                            >{{ item.endpoint_url }}</span
                                        ></v-list-item
                                    >
                                </template>

                                <template v-slot:item.request="{ item }">
                                    <div class="request-log">
                                        <pre class="text-left">{{
                                            JSON.stringify(
                                                item.request,
                                                null,
                                                2
                                            )
                                        }}</pre>
                                    </div>
                                </template>
                            </b-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog
            v-model="detailsDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <b-card
                :title="translations.logsData[lang]"
                @cancel="closeDetailsDialog"
                :submitBtn="false"
            >
                <v-container fluid>
                    <v-data-iterator
                        :items="[detailsData]"
                        :items-per-page="1"
                        hide-default-footer
                    >
                        <template v-slot:header>
                            <v-toolbar class="mb-2" color="secondary" dark flat>
                                <v-col
                                    class="text-h6 font-weight-bold d-flex justify-center align-center"
                                >
                                    <span style="position: absolute;left: 15px;"
                                        >#{{
                                            detailsData.store_event_log_id
                                        }}</span
                                    >
                                    <span
                                        class="ma-3 mt-4 pl-2 pr-2 details-status"
                                        :class="[
                                            statusIsSuccess(detailsData.status)
                                                ? 'success'
                                                : 'error'
                                        ]"
                                        >{{ detailsData.status }}</span
                                    >
                                    [<span class="ma-2 font-weight-regular">{{
                                        detailsData.method
                                    }}</span
                                    >]
                                    <span class="ma-3">{{
                                        detailsData.endpoint_url
                                    }}</span>
                                </v-col>
                            </v-toolbar>
                        </template>
                        <template v-slot:default="props">
                            <v-row
                                v-for="item in props.items"
                                :key="item.name"
                                :class="['d-flex justify-center']"
                            >
                                <v-col
                                    cols="12"
                                    md="12"
                                    lg="6"
                                    xl="6"
                                    v-if="!isEmpty(detailsData)"
                                >
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left"></th>
                                                    <th class="text-left"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>#ID</td>
                                                    <td>
                                                        {{
                                                            detailsData.store_event_log_id
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        {{
                                                            translations.status[
                                                                lang
                                                            ]
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{ detailsData.status }}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>
                                                        {{
                                                            translations.method[
                                                                lang
                                                            ]
                                                        }}
                                                    </td>
                                                    <td>
                                                        {{ detailsData.method }}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>URL</td>
                                                    <td>
                                                        {{
                                                            detailsData.endpoint_url
                                                        }}
                                                    </td>
                                                </tr>

                                                <tr
                                                    v-if="
                                                        detailsData.event_type
                                                    "
                                                >
                                                    <td>
                                                        {{
                                                            translations
                                                                .eventType[lang]
                                                        }}
                                                    </td>
                                                    <td>
                                                        <span
                                                            class="text-capitalize pa-1 pr-0"
                                                            >{{
                                                                detailsData.event_name
                                                            }}
                                                        </span>
                                                        <span
                                                            v-for="(type,
                                                            i) in detailsData.event_type.split(
                                                                '.'
                                                            )"
                                                            :key="i"
                                                            class="text-capitalize pr-1"
                                                        >
                                                            <v-icon
                                                                class="pb-1 pr-1"
                                                                >mdi-arrow-right</v-icon
                                                            >{{ type }}</span
                                                        >
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>

                                <v-col
                                    v-for="(attr, i) in item"
                                    :key="i"
                                    cols="12"
                                    md="12"
                                    lg="6"
                                    xl="4"
                                    :class="[
                                        !isEmpty(attr) &&
                                        typeof attr === 'object'
                                            ? 'd-flex align-center'
                                            : 'display-none'
                                    ]"
                                >
                                    <v-card
                                        style="width: 100%;"
                                        v-if="attr && typeof attr === 'object'"
                                    >
                                        <v-card-title
                                            class="subheading font-weight-bold d-flex justify-center align-center text-capitalize"
                                            style="background: rgba(0,0,0,0.1);"
                                        >
                                            {{ i }}
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-list dense v-if="i === 'headers'">
                                            <v-list-item>
                                                <v-list-item-content
                                                    class="align-end"
                                                >
                                                    <v-simple-table>
                                                        <template
                                                            v-slot:default
                                                        >
                                                            <tbody>
                                                                <tr
                                                                    v-for="k in Object.keys(
                                                                        attr
                                                                    )"
                                                                    :key="k"
                                                                >
                                                                    <td>
                                                                        <span
                                                                            class="d-flex justify-center align-center"
                                                                            style="position: relative;"
                                                                            >{{
                                                                                k
                                                                            }}<v-icon
                                                                                style="position: absolute; right: 0;"
                                                                                >mdi-arrow-right</v-icon
                                                                            ></span
                                                                        >
                                                                    </td>
                                                                    <td>
                                                                        <span
                                                                            class="d-flex justify-center align-center"
                                                                            >{{
                                                                                attr[
                                                                                    k
                                                                                ]
                                                                            }}</span
                                                                        >
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                        <v-list
                                            dense
                                            v-else-if="
                                                attr && typeof attr === 'object'
                                            "
                                        >
                                            <v-list-item>
                                                <v-list-item-content
                                                    class="align-end"
                                                    :key="
                                                        jsonHeights[
                                                            `${i}_${detailsData.store_event_log_id}`
                                                        ]
                                                    "
                                                >
                                                    <v-jsoneditor
                                                        :ref="`${i}`"
                                                        disabled
                                                        :options="jsonOptions"
                                                        :editable="false"
                                                        :plus="false"
                                                        :value="attr"
                                                        :height="
                                                            jsonHeights[
                                                                `${i}`
                                                            ] + 'px'
                                                        "
                                                    ></v-jsoneditor>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>

                        <template v-slot:footer> </template>
                    </v-data-iterator>
                </v-container>
            </b-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mdiPlus, mdiMenuUp, mdiMenuDown } from "@mdi/js";
import { mapMutations, mapState, mapActions, mapGetters } from "vuex";
import translations from "@/utils/translations/general/settings/developers";
import Ajv from "ajv";
import { cloneDeep, delay, isEmpty } from "lodash";
import debounce from "lodash/debounce";

export default {
    name: "WebhookLogs",

    mixins: [translations],

    data() {
        return {
            icons: {
                mdiPlus,
                mdiMenuUp,
                mdiMenuDown
            },
            authTypes: [
                { name: "basic", options: { username: "", password: "" } },
                { name: "api", options: { key: "", value: "" } },
                { name: "bearer", options: { token: "" } }
            ],
            detailsData: {},
            loadedData: {},
            detailsDialog: false,
            jsonOptions: {
                mode: "code",
                mainMenuBar: false,
                statusBar: false,
                ajv: new Ajv({
                    allErrors: true,
                    verbose: true,
                    $data: true,
                    readOnly: true
                }),
                onChange: () => {
                    this.resetData();
                }
            },
            jsonHeights: {
                request: 600,
                response: 600
            },
            isEmpty,
            search: "",

            filteredSearch: "",
            filteredStatus: [],
            filteredEvents: [],
            page: 1
        };
    },
    computed: {
        ...mapState(["loading", "errorMessage", "superUser"]),

        ...mapState("general/settings/developers/webhooks", ["events"]),
        ...mapState("general/settings/developers/webhookLogs", ["webhookLogs"]),

        lang() {
            return this.$route.params.lang;
        },

        locale() {
            if (this.lang == "el") return "el-GR";
            if (this.lang == "it") return "it-IT";
            return "en-GB";
        },

        permission() {
            return (
                this.superUser ||
                (this.$store.state.permissions?.developers
                    ? this.$store.state.permissions.developers.webhooks_logs
                          ?.read
                    : null)
            );
        },

        statuses() {
            return [
                {
                    text: this.translations.success[this.lang],
                    value: "success"
                },
                {
                    text: this.translations.fail[this.lang],
                    value: "fail"
                }
            ];
        },
        webhookAuthName() {
            return Object.keys(this.webhook.authorization || {})?.[0] || "";
        },

        headers() {
            return [
                {
                    text: "ID",
                    value: "store_event_log_id",
                    align: "center"
                },
                {
                    text: this.translations.eventTypes[this.lang],
                    value: "event_type",
                    align: "center"
                },
                {
                    text: this.translations.status[this.lang],
                    value: "status",
                    align: "center",
                    width: 150
                },
                {
                    text: "URL",
                    value: "endpoint_url",
                    align: "center"
                }

                // {
                //     text: "Headers",
                //     value: "headers",
                //     align: "left",
                //     width: 200,
                // },
                // {
                //     text: "Request",
                //     value: "request",
                //     align: "left",
                //     width: 250,
                // },
            ];
        },

        query() {
            let query = `?page=${this.page}`;
            if (this.filteredSearch) {
                query += `&q=${this.filteredSearch}`;
            }
            if (this.filteredStatus?.length) {
                query += `&status=${this.filteredStatus[0].value}`;
            }
            if (this.filteredEvents.length) {
                query += `&event=`;
                for (let event of this.filteredEvents) {
                    query += `${event},`;
                }
                query = query.slice(0, query.length - 1);
            }
            return query; //.slice(0, query.length - 1);
        }
    },
    watch: {
        detailsDialog: {
            // immediate: true,
            handler(val) {
                if (!val) {
                    this.closeDetailsDialog();
                }
            }
        },
        search: {
            handler(val) {
                if (val) {
                    this.debouncedSearch();
                } else {
                    this.filteredSearch = val;
                }
            }
        },
        filteredEvents: {
            deep:true,
            handler(val, prev){
                if (val != prev && this.page != 1) {
                    this.page = 1;
                }
            }
        },
        filteredStatus: {
            deep:true,
            handler(val, prev){
                if ( this.page != 1) {
                    this.page = 1;
                }
            }
        },

        query(val) {
            this.getWebhookLogs({
                query: val
            });
        }
    },
    methods: {
        ...mapActions("general/settings/developers/webhooks", ["getAllEvents"]),
        ...mapActions("general/settings/developers/webhookLogs", [
            "getWebhookLogs"
        ]),
        ...mapMutations(["setDeleteDialog", "setNotification", "setLoading"]),

        localizeDate(date, short) {
            return date
                ? new Date(date).toLocaleString(this.locale, {
                      weekday: short ? undefined : "long",
                      year: "numeric",
                      month: short ? "numeric" : "long",
                      day: "numeric"
                  })
                : "-";
        },
        openDetailsDialog(item) {
            this.detailsData = cloneDeep({ ...item });
            this.loadedData = item;
            this.detailsDialog = true;
            delay(this.getJsonHeight, 500, "request");
            delay(this.getJsonHeight, 500, "response");
        },

        closeDetailsDialog() {
            this.detailsData = {};
            this.loadedData = {};
            this.detailsDialog = false;
            this.loadedData = {};
            this.jsonHeights = {
                request: 600,
                response: 600
            };
        },

        async getJsonHeight(refName) {
            let rowArray =
                this.$refs[refName]?.[0]?.$el?.children[0]?.children[0]
                    ?.children[0]?.children[0]?.children[1]?.children[0] || [];
            let height = 0;
            if (rowArray?.children?.length) {
                height =
                    parseInt(
                        rowArray.children[rowArray.children.length - 1]?.style
                            ?.top
                    ) + 36;
                if (height > 600) {
                    height = 600;
                }
            }
            this.$set(this.jsonHeights, refName, height || 300);
        },

        closeModal() {
            this.$emit("close");
        },

        statusIsSuccess(status) {
            try {
                let s = parseInt(status);
                return s < 203;
            } catch (error) {
                return false;
            }
        },

        resetData() {
            this.detailsData = cloneDeep({ ...this.loadedData });
        },
        handleSearch() {
            if (this.page != 1) {
                this.page = 1;
            }
            this.filteredSearch = this.search;
        },
        removeFilter(name, i) {
            this[name].splice(i, 1);
        },
        resetFilters(){
            this.filteredEvents = []
            this.filteredStatus = []
        }
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 900);
    },
    async mounted() {
        if (!this.events?.length) {
            await this.getAllEvents();
        }
        this.getWebhookLogs(this.query);
    }
};
</script>

<style>
.webhook-logs-table th {
    padding-left: 3px !important;
    padding-right: 3px !important;
}
.webhook-logs-table td {
    padding-left: 3px !important;
    padding-right: 3px !important;
}

.request-log {
    max-height: 200px;
    overflow: scroll;
}
.request-log .v-slide-group__wrapper {
    overflow: scroll;
}
.details-status {
    border-radius: 18px;
}
.details-status.error {
    background: rgba(235, 0, 0, 0.55);
}
.details-status.success {
    background: rgba(0, 235, 67, 0.55);
}
.read-only {
    pointer-events: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.display-none {
    display: none !important;
}
</style>
